var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-todo-card.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/forms/x-checkbox.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { AdornisTodoStatus } from "../db/AdornisTodo.js";
var XTodoCard = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.todo = null;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": { display: "flex", width: "30vw" },
        ".card": {
          alignItems: "flex-start",
          border: "solid",
          borderColor: this.colors.neutral.shade(100),
          borderRadius: this.sizes.borderRadiusSecondary,
          transition: "background .125s ease-in-out",
          background: this.colors.neutral.shade(50),
          maxHeight: "20vh"
        },
        ".card:hover": {
          background: this.colors.neutral.shade(100),
          borderColor: this.colors.tone.success
        }
      }
    ];
  }
  render() {
    if (!this.todo)
      return nothing;
    return xComponents(html`
      <x-flex class="card" space="sm" padding="xxs" w100>
        <x-flex w100 flex horizontal space-between crossaxis-center flex-none>
          <x-text ${css({ color: this.colors.neutral })}>
            Erstellt von: ${this.todo.createdBy?.toString() ?? "System"}
          </x-text>
          <x-text ${css({ color: this.colors.neutral })}> ${this.todo.createdAt?.toFormat("dd.MM.yyyy")} </x-text>
        </x-flex>
        <x-flex w100 horizontal space="md" ${css({ minHeight: "0" })}>
          <x-checkbox
            ${css({ left: 0, position: "sticky", top: 0, alignSelf: "center" })}
            padding="sm"
            @value-picked=${async (e) => {
      if (!this.todo)
        return;
      this.todo.status = e.detail.value ? AdornisTodoStatus.CHECKED : AdornisTodoStatus.OPEN;
      await this.todo.save();
      this.requestUpdate();
    }}
            .value=${this.todo.status === AdornisTodoStatus.CHECKED}
          ></x-checkbox>

          <x-text
            ${acss({
      width: "100%",
      minHeight: "0",
      overflow: "auto",
      overflowWrap: "normal",
      wordBreak: "break-word",
      ...this.todo.status === AdornisTodoStatus.CHECKED ? {
        color: this.colors.neutral.shade(300),
        textDecoration: "line-through"
      } : {},
      "&:before": { margin: "0 !important" },
      "&:after": { margin: "0 !important" },
      p: { margin: "0" }
    })}
          >
            ${unsafeHTML(this.todo.name)}
          </x-text>
        </x-flex>
      </x-flex>
    `);
  }
};
__decorateClass([
  property({ attribute: false })
], XTodoCard.prototype, "todo", 2);
XTodoCard = __decorateClass([
  customElement("x-todo-card")
], XTodoCard);
export {
  XTodoCard
};
